const CLAVE = 'cqinv.scan-session.v1';

export interface SesionLocal {
  readonly sessionId: string;
  readonly companyId: string;
  readonly idempotencyKey: string;
  readonly destination: {
    readonly kind: 'warehouse' | 'zone' | 'holder' | 'customer' | 'maintenance' | 'none';
    readonly warehouseId?: string | null;
    readonly workZoneId?: string | null;
    readonly holderId?: string | null;
    readonly customerId?: string | null;
  };
  readonly tokens: readonly string[];
}

function abrirIdb(): Promise<IDBDatabase | null> {
  if (typeof indexedDB === 'undefined') return Promise.resolve(null);
  return new Promise((resolve, reject) => {
    const req = indexedDB.open('cqinv-scan', 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains('sesiones')) {
        req.result.createObjectStore('sesiones');
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function guardarSesionLocal(datos: SesionLocal): Promise<void> {
  localStorage.setItem(CLAVE, JSON.stringify(datos));
  const db = await abrirIdb();
  if (!db) return;
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction('sesiones', 'readwrite');
    tx.objectStore('sesiones').put(datos, 'actual');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export function haySesionDeEscaneoAbierta(): boolean {
  return Boolean(localStorage.getItem(CLAVE));
}

export async function leerSesionLocal(): Promise<SesionLocal | null> {
  const crudo = localStorage.getItem(CLAVE);
  if (crudo) {
    try {
      return JSON.parse(crudo) as SesionLocal;
    } catch {
      /* IndexedDB */
    }
  }
  const db = await abrirIdb();
  if (!db) return null;
  return new Promise((resolve, reject) => {
    const tx = db.transaction('sesiones', 'readonly');
    const req = tx.objectStore('sesiones').get('actual');
    req.onsuccess = () => resolve((req.result as SesionLocal | undefined) ?? null);
    req.onerror = () => reject(req.error);
  });
}

export async function borrarSesionLocal(): Promise<void> {
  localStorage.removeItem(CLAVE);
  const db = await abrirIdb();
  if (!db) return;
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction('sesiones', 'readwrite');
    tx.objectStore('sesiones').delete('actual');
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}
